import { Box, Fade, Skeleton } from "@mui/material";
import { memo } from "react";

import SondertagCard from "./SondertagCard";
import EmptyAdminState from "./EmptyAdminState";
import EmptyUserState from "./EmptyUserState";
import LockScreen from "./LockScreen";

import { useAppContext } from "../../../2_ksbHub/context/appContext";
import { useSondertagContext } from "../context/sondertagContext";

import useSonderEventLock from "../hooks/useSonderEventLock";
import useSondertagActions from "../hooks/useSondertagActions";

function SondertagMain({ viewMode, dialogs }) {
  const { eventManagerLoading } = useAppContext();

  const {
    isASondertageEventAdmin,
    selectedSonderEvent,
    sondertage = [],
  } = useSondertagContext();

  const { showLockScreen, unlockTime } = useSonderEventLock();

  const actions = useSondertagActions({
    showLockScreen,
  });

  return (
    <Box sx={{ position: "relative" }}>
      {showLockScreen && <LockScreen unlockTime={unlockTime} />}

      {!showLockScreen && (
        <Fade in timeout={750} key={selectedSonderEvent?.id}>
          <Box>
            {/* ✅ EMPTY STATES */}
            {sondertage.length === 0 ? (
              isASondertageEventAdmin ? (
                <EmptyAdminState
                  onCreateJahrgang={() => dialogs.setCreateSondertagOpen(true)}
                  onCreateSonderEvent={() =>
                    dialogs.setCreateSonderEventOpen(true)
                  }
                />
              ) : (
                <EmptyUserState />
              )
            ) : (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {sondertage.map((day) => (
                  <SondertagCard
                    key={day.id}
                    day={day}
                    jahrgaenge={day.jahrgaenge || []}
                    viewMode={viewMode}
                    onDeleteJob={actions.handleDeleteJob}
                    onDeleteSondertag={actions.handleDeleteSondertag}
                    onEditJob={(job) => {
                      dialogs.setEditingJob(job);
                      dialogs.setCreateJobOpen(true);
                    }}
                    onEditSondertag={(sondertag) => {
                      dialogs.setEditingSondertag(sondertag);
                      dialogs.setCreateSondertagOpen(true);
                    }}
                  />
                ))}
              </Box>
            )}

            {/* ✅ LOADING OVERLAY */}
            {eventManagerLoading && (
              <Box sx={{ position: "absolute", inset: 0 }}>
                <Skeleton width="60%" height={40} />
              </Box>
            )}
          </Box>
        </Fade>
      )}
    </Box>
  );
}

export default memo(SondertagMain);
